import LegalPage from "../components/LegalPage";

const EditorialPolicyPage = () => (
    <LegalPage
        title="Editorial Policy"
        eyebrow="How our content is made"
        updated="28 September 2026"
        description="How SahiKhoj blog articles and guides are researched, drafted, reviewed and updated — including our use of AI assistance and our fact-checking standards."
        path="/editorial-policy"
        testId="editorial-policy"
        intro="The SahiKhoj blog publishes practical shopping and saving guides for Indian consumers. This page explains how that content is created, checked and maintained."
        sections={[
            {
                heading: "What we publish",
                body: [
                    "We publish how-to guides, buying frameworks, saving strategies and explainers about price comparison, deals, coupons, flights and hotels. The goal of every article is to help a reader make a better decision — not to push a particular store or product.",
                    "We deliberately publish fewer, more useful articles rather than large volumes of thin content.",
                ],
            },
            {
                heading: "How articles are researched",
                body: [
                    "Topics are chosen based on what genuinely helps shoppers: common overpayment mistakes, seasonal sale patterns, and questions about comparing products or travel fares. Articles explain methods and verification steps a reader can repeat themselves, instead of quoting prices or deals that may be outdated within days.",
                    "Where an article makes a factual claim, our process is to verify it against a primary or authoritative source before publishing.",
                ],
            },
            {
                heading: "AI assistance, always human-reviewed",
                body: [
                    "We use an internal research tool that suggests topics and produces early drafts. These drafts are never published automatically. Every draft goes through human review by the SahiKhoj editorial team, which checks facts, prices, dates, links and originality before an article is approved.",
                    "Articles that were drafted with AI assistance carry a note saying so on the article page. We do not present machine-drafted text as independent human reporting.",
                ],
            },
            {
                heading: "What we do not publish",
                body: [
                    "We do not invent prices, discounts, ratings, reviews, product specifications, statistics or user numbers. We do not publish copied or scraped content, and we do not publish articles whose only purpose is to send you to a merchant.",
                    "Where live data cannot be verified, we say so on the page instead of guessing.",
                ],
            },
            {
                heading: "Editorial content vs comparison data",
                body: [
                    "Prices and offers shown in comparison features come from the respective platforms and are data, not opinion. Blog articles are editorial content written by our team. We keep the two clearly separate, and affiliate relationships do not influence either — see the Affiliate Disclosure for details.",
                ],
            },
            {
                heading: "Languages",
                body: [
                    "Many articles are available in English and Hindi. Hindi versions are written as natural Hindi articles rather than word-for-word translations, so examples and phrasing may differ slightly between versions while the guidance stays the same.",
                ],
            },
            {
                heading: "Updates and corrections",
                body: [
                    "Articles show their publication date and, where applicable, an updated date. If we find an error — or a reader points one out — we correct the article and refresh the updated date. To report a correction, email us with the article link and what looks wrong.",
                ],
            },
        ]}
    />
);

export default EditorialPolicyPage;
